import { isDefined } from "../components/Generic/IsDefined";
import { AddressComponents } from "../messages";

export function getLocationDisplayLocation(location: AddressComponents): string {
  return [
    location.administrativeAreaLevel1,
    location.sublocalityLevel1,
    location.neighborhood,
    location.locality,
  ]
    .filter(isDefined)
    .join(" ");
}
